import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-fcfd33f4"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 1,
  class: "main"
};
const _hoisted_2 = {
  class: "container"
};
const _hoisted_3 = {
  key: 1,
  class: "news-detail__top--recommend card"
};
const _hoisted_4 = {
  key: 2,
  class: "news-detail__top--recommend card"
};
const _hoisted_5 = {
  class: "card"
};
const _hoisted_6 = {
  key: 0,
  class: "artical-source"
};
const _hoisted_7 = ["name", "href"];
const _hoisted_8 = {
  key: 3,
  class: "card"
};
const _hoisted_9 = ["href"];
const _hoisted_10 = {
  key: 4,
  class: "news-detail__inquiry news-detail-inquiry__form card"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, " 填写询价 ", -1));
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("iframe", {
  src: "https://b2b.baidu.com/m/inquiry?nobar=1&noheader=1&oversea=1&fid=671154177",
  class: "news-detail__inquiry--iframe"
}, null, -1));
const _hoisted_13 = [_hoisted_11, _hoisted_12];
const _hoisted_14 = {
  key: 5,
  class: "news-detail__bottom card"
};
const _hoisted_15 = {
  key: 0,
  class: "news-detail__right"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "news-detail-inquiry__form"
}, [/*#__PURE__*/_createElementVNode("h2", null, " 填写询价 "), /*#__PURE__*/_createElementVNode("iframe", {
  src: "https://b2b.baidu.com/m/inquiry?nobar=1&noheader=1&oversea=1&fid=671154177",
  class: "news-detail__inquiry--iframe"
})], -1));
const _hoisted_17 = [_hoisted_16];
const _hoisted_18 = {
  key: 1,
  class: "news-detail__aibot"
};
const _hoisted_19 = {
  class: "go-bot"
};
const _hoisted_20 = {
  class: "common-scene"
};
const _hoisted_21 = {
  class: "content"
};
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ai-tag-img"
}, null, -1));
const _hoisted_23 = ["href"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_illegal_id = _resolveComponent("illegal-id");
  const _component_detail_header = _resolveComponent("detail-header");
  const _component_el_divider = _resolveComponent("el-divider");
  const _component_news_recommend_product_list = _resolveComponent("news-recommend-product-list");
  const _component_detail_content = _resolveComponent("detail-content");
  const _component_update_time = _resolveComponent("update-time");
  const _component_t_nav_news = _resolveComponent("t-nav-news");
  const _component_el_button = _resolveComponent("el-button");
  const _component_client_only = _resolveComponent("client-only");
  const _component_detail_footer = _resolveComponent("detail-footer");
  const _component_t_layout = _resolveComponent("t-layout");
  return _openBlock(), _createBlock(_component_t_layout, {
    "is-white-bg": true,
    "is-header-padding": true,
    "wise-header-size": "small",
    class: "news-detail-wrap"
  }, {
    default: _withCtx(() => {
      var _ctx$recommendProduct, _ctx$data$data, _ctx$recommendProduct2, _ctx$data$data2;
      return [_ctx.data.hasError ? (_openBlock(), _createBlock(_component_illegal_id, {
        key: 0
      })) : _ctx.data ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_ctx.data ? (_openBlock(), _createBlock(_component_detail_header, {
        key: 0,
        data: _ctx.header,
        "is-loading": _ctx.data.isLoading
      }, null, 8, ["data", "is-loading"])) : _createCommentVNode("", true), _createVNode(_component_el_divider, {
        class: "divider"
      }), _ctx.isMobile && _ctx.loading ? (_openBlock(), _createElementBlock("section", _hoisted_3, [_createVNode(_component_news_recommend_product_list, {
        "header-visible": false,
        loading: true,
        "skeleton-num": 2,
        "log-info": {
          'product_recommend_query': _ctx.productRecommendQuery
        }
      }, null, 8, ["log-info"])])) : _createCommentVNode("", true), _ctx.isMobile && (_ctx$recommendProduct = _ctx.recommendProduct) !== null && _ctx$recommendProduct !== void 0 && _ctx$recommendProduct.length ? (_openBlock(), _createElementBlock("section", _hoisted_4, [_createVNode(_component_news_recommend_product_list, {
        "header-visible": false,
        loading: _ctx.loading,
        keywords: ((_ctx$data$data = _ctx.data.data) === null || _ctx$data$data === void 0 ? void 0 : _ctx$data$data.flutter) || '',
        list: _ctx.recommendProduct.slice(0, 2),
        "log-info": {
          'product_recommend_query': _ctx.productRecommendQuery
        },
        "component-alias": "top-recommend"
      }, null, 8, ["loading", "keywords", "list", "log-info"])])) : _createCommentVNode("", true), _createElementVNode("section", _hoisted_5, [_createVNode(_component_detail_content, {
        "is-loading": _ctx.data.isLoading,
        data: _ctx.data.data
      }, null, 8, ["is-loading", "data"]), _ctx.header.source_link ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createTextVNode(" 来源： "), _createElementVNode("a", {
        name: `资讯来源：${_ctx.header.source_link}`,
        href: _ctx.header.source_link,
        target: "_blank"
      }, _toDisplayString(_ctx.header.source), 9, _hoisted_7)])) : _createCommentVNode("", true)]), _ctx.isSpider ? (_openBlock(), _createElementBlock("section", _hoisted_8, [_createElementVNode("a", {
        href: _ctx.handleUrl('mergelist'),
        target: "_blank"
      }, " 查看更多跨境电商文章 ", 8, _hoisted_9), _createVNode(_component_update_time), _createVNode(_component_t_nav_news, {
        "nav-news-cards": _ctx.navCardList
      }, null, 8, ["nav-news-cards"])])) : _createCommentVNode("", true), _ctx.isMobile ? (_openBlock(), _createElementBlock("section", _hoisted_10, _hoisted_13)) : _createCommentVNode("", true), (_ctx$recommendProduct2 = _ctx.recommendProduct) !== null && _ctx$recommendProduct2 !== void 0 && _ctx$recommendProduct2.length ? (_openBlock(), _createElementBlock("section", _hoisted_14, [_createVNode(_component_news_recommend_product_list, {
        loading: _ctx.loading,
        keywords: (_ctx$data$data2 = _ctx.data.data) === null || _ctx$data$data2 === void 0 ? void 0 : _ctx$data$data2.flutter,
        list: _ctx.isMobile ? _ctx.recommendProduct.slice(2, _ctx.recommendProduct.length) : _ctx.recommendProduct,
        "component-alias": "recommend",
        "log-info": {
          'product_recommend_query': _ctx.productRecommendQuery
        }
      }, null, 8, ["loading", "keywords", "list", "log-info"])])) : _createCommentVNode("", true)]), !_ctx.isMobile ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_17)) : _createCommentVNode("", true), _ctx.isMobile ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_createVNode(_component_client_only, null, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_hoisted_22, _createElementVNode("div", null, _toDisplayString(_ctx.TIPS_LIST[Math.floor(Math.random() * 6)]), 1)]), _createElementVNode("a", {
          class: "aibot-link",
          href: _ctx.aibotUrl
        }, [_createVNode(_component_el_button, {
          class: "aibot-go-btn"
        }, {
          default: _withCtx(() => [_createTextVNode("去提问")]),
          _: 1
        })], 8, _hoisted_23)])])]),
        _: 1
      })])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), !_ctx.data.hasError ? (_openBlock(), _createBlock(_component_detail_footer, {
        key: 2,
        data: _ctx.data.data
      }, null, 8, ["data"])) : _createCommentVNode("", true)];
    }),
    _: 1
  });
}